import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, TextStyled, HeadingStyled, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown, HeroBg, HeroBgAr, IconBg, IconBg2, Lights, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import { BenefitsList1 } from '../../projectData/Data'
// import ServicesBlocks from './benefitsContent/BenefitsBlocks'
const Benefits = () => {
    const { t } = useTranslation();
    const WhatsApp = () => {
        const phoneNumber = '+966567974344';
        const message = 'Hello, this is  Soola';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    return (
        <>
            <BenefitsWapper className='container-fluid common-space servicesFluid' id="benefits">
                <Container>
                    <Box className='benefitsRow row'>
                        <Col md={12} className="benefitsColMain headingColMain">
                            <Box className='benefitsDescCol1Content'>
                                <MainHeading className='main-heading mb-3 benefitsMH text-center'>
                                    {t('ChaosTitle')}  
                                </MainHeading>
                                <SpanStyled className='d-flex mb-4 transformTxt text-center' size="18px">
                                    {t('ChaosDescription')}
                                </SpanStyled>
                            </Box>
                            
                            
                        </Col>
                        <Col md={12} className="benefitsColBlocks">
                            <Row className='benefitsGridCol'>
                                {BenefitsList1.map((item, index) => (
                                    
                                    <Col md={6} lg={3} className="benefitsColBlocks" key={index}>
                                        <Box className="benefitsColBlocksInner">
                                            <Box className="cardIcon mb-3">
                                                {item.icon}
                                            </Box>
                                            <MainHeading className='main-heading mb-3 benefitsHeading' size="18px">
                                                {t(item.title)}
                                            </MainHeading>
                                            <SpanStyled className='d-flex benefitsTxt'>
                                                {t(item.txt)}
                                            </SpanStyled>
                                        </Box>
                                    </Col>
                                    
                                ))}
                            </Row>
                            {/* <ServicesBlocks /> */}
                        </Col>
                    </Box>
                </Container>
            </BenefitsWapper>
        </>
    )
}
const BenefitsWapper = styled.section`
    padding-bottom: 0px;
    
    .benefitsColMain{
        display: flex;
        justify-content: center;
        width: 100%;
        
    }
    
    .benefitsRow{
        /* margin-left: 0;
        margin-right: 0; */
    }
    
    .benefitsDescCol1Content{
        display: inline-block;
        
    }
    .servicesDescCol2{
        display: flex;
        justify-content: center;
        padding-left: 200px;
        .servicesDescCol2Content{
            display: inline-block;
            width: 320px;
        }
    }
    .benefitsColBlocksInner{
        display: flex;
        height: 100%;
        width: 100%;
        background-image: url(${IconBg2});
        background-repeat: no-repeat;
        background-position: top 6px right 6px;
        background-color: var(--white);
        border-radius: 16px;
        border: 1px solid var(--stroke);
        flex-direction: column;
        padding: 24px;
        box-shadow: 0px 6px 34px -12px rgb(64, 146, 255, .5);
        -webkit-box-shadow: 0px 6px 34px -12px rgb(64, 146, 255, .5);
        -moz-box-shadow: 0px 6px 34px -12px rgb(64, 146, 255, .5);
    }
        
    
    body.rtl &{
        & > .container{
            /* .servicesMH{
                font-size: 40px;
            } */
            .servicesIH{
                font-size: 28px
            }
            .servicesDescCol2 {
                padding-left: 0;
                padding-right: 200px;
            }
           
        }
        .benefitsHeading{
            font-size: 18px;
        }
        .benefitsColBlocksInner{
            background-position: top 6px left 6px;
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            
        }
        body.rtl &{
            & > .container{
                
                
            }
        }
    }
    @media (max-width: 1199px) {
        & > .container{
            
            
        }
        body.rtl &{
            & > .container{
                .lights {
                    left: 32%;
                }
                
            }
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .servicesDescCol{
                padding: 0;
                
            }
            .benefitsMH{
                font-size: 40px;
            }
            .benefitsDescCol1Content {
                max-width: 100%;
            }
            .servicesDescCol1{
                justify-content: flex-start;
                margin-bottom: 10px;
            }
            .servicesDescCol2{
                .servicesDescCol2Content{
                    width: 100%;
                }
            } 
            
            
        }
        .benefitsColBlocks{
            margin-bottom: 20px;
        }
        body.rtl &{
            & > .container{
                .benefitsDescCol1Content {
                    max-width: 100%;
                }
                .servicesDescCol2 {
                    padding-left: 0;
                    padding-right: 0;
                }
                .benefitsMH{
                    font-size: 40px;
                }
                .servicesIH{
                    font-size: 24px;
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .benefitsMH{
                font-size: 35px;
            }
            .servicesIH{
                font-size: 24px;
            }
            .transformTxt{
                font-size: 18px;
            }
            
        }
        body.rtl &{
            & > .container{
                .benefitsMH{
                    font-size: 28px;
                }
                .servicesIH{
                    font-size: 24px;
                }
                .transformTxt{
                    font-size: 18px;
                }
                
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        .benefitsHeading{
            font-size: 18px;
        }
    }
    @media (max-width: 350px) {
        
    }
`
export default Benefits
